import { Text, VStack } from "@chakra-ui/layout";
import { Layout } from "ui/src/components/HomeDomain/Layout";
import { MainHero } from "ui/src/components/HomeDomain/MainHero";

const AboutPage = () => (
  <Layout title="About | TheLastWeekIn.Dev">
    <MainHero byline="What? Why? When? How??" />
    <VStack textAlign="center" spacing={12} mb={16}>
      <Text fontSize="4xl">🌈 🌈 🌈</Text>
      <Text fontSize="2xl" fontWeight="bold">
        TLWI.dev is a love story to the dev community.
      </Text>
      <Text fontSize="2xl">
        It was born out of a desire to keep a finger on the pulse of different
        communities, as well as a way to connect and hear from not-so-well known
        sources.
      </Text>
      <Text fontSize="2xl">
        As TLWI.dev grows, the newsletters and community submission features too
        will grow.
      </Text>
      <Text fontSize="2xl">
        My hope is that these newsletters become a source of knowledge and
        inspiration for your day-to-day work and journey into code!
      </Text>
      <Text fontSize="4xl">🌈 🌈 🌈</Text>
    </VStack>
  </Layout>
);

export default AboutPage;
